import { render } from "./Auctions.vue?vue&type=template&id=1f81273a"
import script from "./Auctions.vue?vue&type=script&lang=js"
export * from "./Auctions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/Auctions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f81273a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f81273a', __exports__)) {
    api.reload('1f81273a', __exports__)
  }
  
  module.hot.accept("./Auctions.vue?vue&type=template&id=1f81273a", () => {
    api.rerender('1f81273a', render)
  })

}


export default __exports__